import React from 'react';
import styled from 'styled-components';
import { color, space, layout } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { useSelector } from 'react-redux';
import PublishingHistory from 'components/publishing-history';
import TopSelling from 'components/top-selling';
import AddNewContent from 'components/add-new-content';
import ServicesCards from 'components/dashboard/service-cards';
import ScopeGate from 'components/scope-gate';
import LockedSection from 'theme/locked-section';
import Text from 'theme/text';
import translations from 'translations';

const Wrapper = styled.div`
  ${space}
  ${color}
  ${layout}

  display: flex;
  flex-direction: column;

  /* Stacked under the content on a phone, so it takes the width it is given;
     beside it from the first breakpoint up, where 236px is what it needs. */
  @media (min-width: ${themeGet('breakpoints.0')}) {
    min-width: 236px;
  }
`;

function Sidebar() {
  const { languageCode } = useSelector((state) => state.config);

  return (
    <Wrapper
      width={['100%', '236px', '236px', '320px']}
      /* Stacked under the content it is the page, so it needs both margins;
         beside the content only the right one, as before. */
      pl={['s', 0, 0, 0]}
      pr="s"
      mt={['m', 0, 0, 0]}
      bg="white"
    >
      <AddNewContent />

      <ServicesCards />

      <Text
        fontSize={['h3', 'h3', 'h3', 'h2']}
        lineHeight={['h3', 'h3', 'h3', 'h2']}
        fontWeight="bold"
        mt="m"
        mb="xs"
        color="grey_600"
      >
        {translations[languageCode]['publishing history']}
      </Text>
      <ScopeGate
        section="catalog"
        fallback={<LockedSection width="100%" minHeight="120px" />}
      >
        <PublishingHistory />
      </ScopeGate>
      <Text
        fontSize={['h3', 'h3', 'h3', 'h2']}
        lineHeight={['h3', 'h3', 'h3', 'h2']}
        fontWeight="bold"
        mt="m"
        mb="xs"
        color="grey_600"
      >
        {translations[languageCode]['top selling titles']}
      </Text>
      <Text
        fontSize={['h6', 'h6', 'h6', 'h5']}
        lineHeight={['h6', 'h6', 'h6', 'h6']}
        fontWeight="bold"
        mb="xs"
        color="grey_200"
      >
        {translations[languageCode]['last 30 days']}
      </Text>
      <ScopeGate
        section="analytics"
        fallback={<LockedSection width="100%" minHeight="120px" />}
      >
        <TopSelling />
      </ScopeGate>
    </Wrapper>
  );
}

export default Sidebar;
